import { render } from "./VerPermisos.vue?vue&type=template&id=7baf4ef1&scoped=true"
import script from "./VerPermisos.vue?vue&type=script&lang=js"
export * from "./VerPermisos.vue?vue&type=script&lang=js"

import "./VerPermisos.vue?vue&type=style&index=0&id=7baf4ef1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7baf4ef1"]])

export default __exports__